import React from 'react';
import { useHistory } from "react-router-dom";
import {
  Box,
  Text,
  VStack,
  HStack,
  Button,
} from '@chakra-ui/react';

const EntityTab = ({ task }) => {
  console.log("task", task);
  
  const history = useHistory();

  const handleGoToRS = () => {
    if (task?.relatedProjectCode) {
      // ✅ New tab me open karne ke liye window.open use karo
      const url = `/home/ap/trello/details/${task.relatedProjectCode}`;
      window.open(url, '_blank');
    }
  };

  return (
    <VStack align="stretch" spacing={6}>

      {/* GO TO RS BUTTON */}
      <HStack justify="flex-end">
        <Button
          onClick={handleGoToRS}
          size="sm"
          bg="blue.500"
          color="white"
          px={4}
          py={2}
          borderRadius="md"
          fontSize="12px"
          fontWeight="600"
          _hover={{ bg: "blue.600", transform: "translateY(-1px)", boxShadow: "md" }}
          _active={{ bg: "blue.700" }}
        >
          Go to RS
        </Button>
      </HStack>

      {/* ENTITY DETAILS */}
      <Box>
        <Text fontSize="12px" fontWeight="600" color="#6B778C" mb={2} textTransform="uppercase">
          Entity Details
        </Text>
        <VStack align="stretch" spacing={3}>
          <HStack justify="space-between">
            <Text fontSize="12px" color="#6B778C">Entity ID</Text>
            <Text fontSize="12px" color="#172B4D">{task?.entityId || 'N/A'}</Text>
          </HStack>

          <HStack justify="space-between">
            <Text fontSize="12px" color="#6B778C">Entity</Text>
            <Text fontSize="12px" color="#172B4D">{task?.entity || 'N/A'}</Text>
          </HStack>

          <HStack justify="space-between">
            <Text fontSize="12px" color="#6B778C">Type</Text>
            <Text fontSize="12px" color="#172B4D" textTransform="capitalize">
              {task?.type || 'Task'}
            </Text>
          </HStack>

          <HStack justify="space-between">
            <Text fontSize="12px" color="#6B778C">Status</Text>
            <Text fontSize="12px" color="#172B4D" textTransform="capitalize">
              {task?.status || 'Active'}
            </Text>
          </HStack>

          <HStack justify="space-between">
            <Text fontSize="12px" color="#6B778C">Position</Text>
            <Text fontSize="12px" color="#172B4D">{task?.position || 'N/A'}</Text>
          </HStack>
        </VStack>
      </Box>

      {/* ENTITY METADATA */}
      {/* {task?.metadata && (
        <Box>
          <Text fontSize="12px" fontWeight="600" color="#6B778C" mb={2} textTransform="uppercase">
            Entity Metadata
          </Text>
          <VStack align="stretch" spacing={3}>
            {Object.entries(task.metadata).map(([key, value]) => (
              <HStack key={key} justify="space-between">
                <Text fontSize="12px" color="#6B778C" textTransform="capitalize">
                  {key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                </Text>
                <Text fontSize="12px" color="#172B4D">
                  {typeof value === 'object' ? JSON.stringify(value) : value?.toString() || 'N/A'}
                </Text>
              </HStack>
            ))}
          </VStack>
        </Box>
      )} */}

      {/* ENTITY PROPERTIES */}
      {/* <Box>
        <Text fontSize="12px" fontWeight="600" color="#6B778C" mb={2} textTransform="uppercase">
          Entity Properties
        </Text>
        <VStack align="stretch" spacing={3}>
          <HStack justify="space-between">
            <Text fontSize="12px" color="#6B778C">Entity Source</Text>
            <Text fontSize="12px" color="#172B4D">{task?.entitySource || 'System'}</Text>
          </HStack>

          <HStack justify="space-between">
            <Text fontSize="12px" color="#6B778C">Entity Version</Text>
            <Text fontSize="12px" color="#172B4D">{task?.entityVersion || '1.0'}</Text>
          </HStack>

          <HStack justify="space-between">
            <Text fontSize="12px" color="#6B778C">Entity Owner</Text>
            <Text fontSize="12px" color="#172B4D">{task?.entityOwner?.name || task?.createdBy?.name || 'Unknown'}</Text>
          </HStack>

          <HStack justify="space-between">
            <Text fontSize="12px" color="#6B778C">Entity Category</Text>
            <Text fontSize="12px" color="#172B4D">{task?.category || 'General'}</Text>
          </HStack>

          <HStack justify="space-between">
            <Text fontSize="12px" color="#6B778C">Entity Tags</Text>
            <Text fontSize="12px" color="#172B4D">
              {task?.tags?.join(', ') || 'No tags'}
            </Text>
          </HStack>
        </VStack>
      </Box> */}

      {/* ENTITY RELATIONSHIPS */}
      {/* {task?.relationships && task.relationships.length > 0 && (
        <Box>
          <Text fontSize="12px" fontWeight="600" color="#6B778C" mb={2} textTransform="uppercase">
            Entity Relationships
          </Text>
          <VStack align="stretch" spacing={3}>
            {task.relationships.map((relationship, index) => (
              <HStack key={index} justify="space-between">
                <Text fontSize="12px" color="#6B778C">{relationship.type || 'Related to'}</Text>
                <Text fontSize="12px" color="#172B4D">{relationship.target || relationship.name || 'N/A'}</Text>
              </HStack>
            ))}
          </VStack>
        </Box>
      )} */}

      {/* ENTITY PERMISSIONS */}
      {/* <Box>
        <Text fontSize="12px" fontWeight="600" color="#6B778C" mb={2} textTransform="uppercase">
          Entity Permissions
        </Text>
        <VStack align="stretch" spacing={3}>
          <HStack justify="space-between">
            <Text fontSize="12px" color="#6B778C">Read Access</Text>
            <Text fontSize="12px" color="#172B4D">{task?.permissions?.read ? 'Granted' : 'Public'}</Text>
          </HStack>

          <HStack justify="space-between">
            <Text fontSize="12px" color="#6B778C">Write Access</Text>
            <Text fontSize="12px" color="#172B4D">{task?.permissions?.write ? 'Granted' : 'Restricted'}</Text>
          </HStack>

          <HStack justify="space-between">
            <Text fontSize="12px" color="#6B778C">Delete Access</Text>
            <Text fontSize="12px" color="#172B4D">{task?.permissions?.delete ? 'Granted' : 'Restricted'}</Text>
          </HStack>
        </VStack>
      </Box> */}
    </VStack>
  );
};

export default EntityTab;
